<template>
  <div id="factura-impresion" style="width: 80mm; padding: 5mm; font-family: sans-serif; font-size: 14px">
		<h1 style="text-align: center; font-size: 20px; font-weight: 400">Q'leko</h1>
		<br>
		<p>Fecha: {{ ahora.toLocaleString() }}</p>
		<br>
		<table style="width: 100%">
			<thead>
				<tr>
					<th style="border-bottom: 1px dashed silver; font-weight: 500; text-align: left;">Cnt</th>
					<th style="border-bottom: 1px dashed silver; font-weight: 500; text-align: left;">Descripción</th>
					<th style="border-bottom: 1px dashed silver; font-weight: 500; text-align: right;">Precio</th>
				</tr>
			</thead>
			<tbody style="font-size: 90%">
				<tr>
					<td style="border-bottom: 1px dashed silver; padding: 2px;">{{ 1 }}</td>
					<td style="border-bottom: 1px dashed silver; padding: 2px;">{{ descripción }}</td>
					<td style="border-bottom: 1px dashed silver; padding: 2px; text-align: right;">{{ Intl.NumberFormat('es').format(precio) }}</td>
				</tr>
			</tbody>
		</table>
		<div style="display: flex; margin-top: 20px">
			<div style="flex-grow: 1"></div>
			<table style="font-size: 95%">
				<tbody>
					<tr>
						<td style="text-align: right;">TOTAL:</td>
						<td style="text-align: right; padding: 0 10px;">{{ Intl.NumberFormat('es').format(precio) }}</td>
					</tr>
				</tbody>
			</table>
		</div>
  </div>
</template>

<script>

export default {
	data: () => ({
		ahora: new Date()
	}),
	props: {
		precio: String,
		descripción: String,
	},
	methods: {
		imprimir: function() {
			let ele = document.getElementById('factura-impresion')
			let ven = window.open('', '', 'left=0,top=0,width=350,height=900,toolbar=0,scrollbars=1,status=0')
			ven.document.write(ele.outerHTML)
			ven.document.close()
			let style = document.createElement('style');
			style.type = 'text/css';
			style.innerHTML = '@media print { @page { margin: 0; size: 8cm; } }';
			ven.document.getElementsByTagName('head')[0].appendChild(style)
			ven.focus()
			ven.print()
			ven.close()
		},
		imprimir2: function() {
			let ele = document.getElementById('factura-impresion')
			let ven = window.open('', '', 'left=0,top=0,width=350,height=900,toolbar=0,scrollbars=1,status=0')
			ven.document.write(ele.outerHTML)
			ven.document.close()
			let style = document.createElement('style');
			style.type = 'text/css';
			style.innerHTML = '@media print { @page { margin: 0; size: 8cm; } }';
			ven.document.getElementsByTagName('head')[0].appendChild(style)
			ven.focus()
		}
	}
}

</script>
